import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import logo from "./logo.png";
import Navbar from "../components/Navbar";

const HomeContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
`;

const Header = styled.header`
  margin-bottom: 30px;
  text-align: center;
`;

const Logo = styled.img`
  height: 80px;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 32px;
  color: #333;
  text-align: center;
  margin: 0 0 10px 0;
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: #666;
  text-align: center;
  margin: 0 0 30px 0;
`;

const SectionTitle = styled.h2`
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const RefreshButton = styled.button`
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    background-color: #3367d6;
  }
`;

const AdvertisersList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

const AdvertiserCard = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  }
`;

const AdvertiserName = styled.h3`
  font-size: 18px;
  color: #333;
  margin: 0 0 10px 0;
`;

const AdvertiserInfo = styled.div`
  margin-bottom: 15px;
`;

const InfoItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 14px;
`;

const InfoLabel = styled.span`
  color: #666;
`;

const InfoValue = styled.span`
  font-weight: 500;
  color: #333;
`;

const ActionButton = styled.button`
  background-color: ${(props) => (props.primary ? "#4285f4" : "#f5f5f5")};
  color: ${(props) => (props.primary ? "white" : "#333")};
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  flex: 1;
  margin: 0 5px;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${(props) => (props.primary ? "#3367d6" : "#e0e0e0")};
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 18px;
  color: #666;
`;

const ErrorContainer = styled.div`
  background-color: #ffebee;
  color: #c62828;
  padding: 15px;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
`;

const DateRangeSelector = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const DateInputGroup = styled.div`
  display: flex;
  gap: 15px;
`;

const DateInputContainer = styled.div`
  flex: 1;
`;

const DateInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
`;

const DateRangeLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
`;

const HeaderButtons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
`;

const HeaderButton = styled.button`
  background-color: ${(props) => (props.secondary ? "#f5f5f5" : "#4285f4")};
  color: ${(props) => (props.secondary ? "#333" : "white")};
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${(props) => (props.secondary ? "#e0e0e0" : "#3367d6")};
  }
`;

// Nouveau style pour le header avec informations utilisateur
const UserInfo = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

const UserName = styled.span`
  margin-right: 15px;
  font-weight: 500;
`;

const LogoutButton = styled.button`
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #d32f2f;
  }
`;

const HeaderTop = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

// Nouveau style pour la barre de recherche
const SearchContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.3s;

  &:focus {
    border-color: #4285f4;
    outline: none;
    box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
  }
`;

const SearchIcon = styled.span`
  color: #666;
  font-size: 18px;
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 16px;
  padding: 5px;

  &:hover {
    color: #f44336;
  }
`;

const NoResultsContainer = styled.div`
  text-align: center;
  padding: 30px;
  background-color: #f5f5f5;
  border-radius: 8px;
  color: #666;
  font-size: 16px;
`;
const SalesPersonFilter = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const SalesPersonSelect = styled.select`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  flex: 1;
`;

function HomePage({ user, onLogout }) {
  const [advertisers, setAdvertisers] = useState([]);
  const [allAdvertisers, setAllAdvertisers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [generatingReport, setGeneratingReport] = useState(null);
  const [userRole, setUserRole] = useState("");
  const [salesPersons, setSalesPersons] = useState([]);
  const [selectedSalesPerson, setSelectedSalesPerson] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [syncing, setSyncing] = useState(false);
  const [syncMessage, setSyncMessage] = useState("");
  const navigate = useNavigate();

  const apiUrl =
    process.env.REACT_APP_API_URL || "https://report-campaign.sirdata.io";
  const fetchAdvertisers = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(`${apiUrl}/api/xandr/advertisers`);
      const advertisersData = response.data.advertisers || [];

      setAllAdvertisers(advertisersData);
      setAdvertisers(advertisersData);
      setUserRole(response.data.userRole || "");

      const uniqueSalesPersons = extractUniqueSalesPersons(advertisersData);
      const normalizedSalesPersons = uniqueSalesPersons.reduce(
        (acc, person) => {
          const normalized = person.replace(/\s+/g, " ").toLowerCase().trim();
          if (
            !acc.some(
              (p) => p.replace(/\s+/g, " ").toLowerCase().trim() === normalized
            )
          ) {
            acc.push(person);
          }
          return acc;
        },
        []
      );
      setSalesPersons(normalizedSalesPersons);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        onLogout();
        navigate("/login");
      } else {
        setError(`Erreur lors du chargement des annonceurs: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  }, [apiUrl, navigate, onLogout]);
  useEffect(() => {
    fetchAdvertisers();
    // Initialiser les dates par défaut (30 derniers jours)
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    setEndDate(today.toISOString().split("T")[0]);
    setStartDate(thirtyDaysAgo.toISOString().split("T")[0]);
  }, [fetchAdvertisers]);
  const applyFilters = (
    newSearchTerm = searchTerm,
    newSalesPerson = selectedSalesPerson
  ) => {
    if (!allAdvertisers || !Array.isArray(allAdvertisers)) {
      console.error(
        "allAdvertisers n'est pas un tableau valide:",
        allAdvertisers
      );
      return;
    }

    const filtered = allAdvertisers.filter((advertiser) => {
      const matchesSearch =
        !newSearchTerm ||
        advertiser.name.toLowerCase().includes(newSearchTerm.toLowerCase());

      const matchesSalesPerson =
        !newSalesPerson ||
        advertiser.salesPerson.replace(/\s+/g, " ").toLowerCase().trim() ===
          newSalesPerson.replace(/\s+/g, " ").toLowerCase().trim();

      return matchesSearch && matchesSalesPerson;
    });

    setAdvertisers(filtered);
  };

  const extractUniqueSalesPersons = (advertisers) => {
    const uniqueSalesPersons = new Set();

    advertisers.forEach((advertiser) => {
      if (advertiser.salesPerson && advertiser.salesPerson !== "Non assigné") {
        uniqueSalesPersons.add(advertiser.salesPerson);
      }
    });

    return Array.from(uniqueSalesPersons).sort();
  };

  const syncAdvertisers = async () => {
    setSyncing(true);
    setSyncMessage("");
    try {
      const response = await axios.post(`${apiUrl}/api/xandr/sync-advertisers`);
      if (response.data.success) {
        setSyncMessage(response.data.message);
        fetchAdvertisers();
      }
    } catch (error) {
      setError(`Erreur lors de la synchronisation: ${error.message}`);
    } finally {
      setSyncing(false);
    }
  };

  const handleCreateReport = async (advertiserId) => {
    try {
      setGeneratingReport(advertiserId);

      if (!startDate || !endDate) {
        setError("Veuillez sélectionner une date de début et de fin");
        setGeneratingReport(null);
        return;
      }
      const response = await axios.post(
        `${apiUrl}/api/xandr/create-advertiser-report`,
        {
          advertiserId,
          customDateRange: {
            startDate,
            endDate,
          },
        }
      );

      if (response.data.success) {
        navigate(`/dashboard/${response.data.dataId}`);
      } else {
        setError("Une erreur est survenue lors de la création du rapport");
      }
    } catch (err) {
      setError(`Erreur lors de la création du rapport: ${err.message}`);
    } finally {
      setGeneratingReport(null);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR");
  };

  const handleLogout = () => {
    onLogout();
    navigate("/login");
  };

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value;
    setSearchTerm(newSearchTerm);
    applyFilters(newSearchTerm, selectedSalesPerson);
  };

  const clearSearch = () => {
    setSearchTerm("");
    applyFilters("", selectedSalesPerson);
  };

  const filterBySalesPerson = (event) => {
    applyFilters(searchTerm, selectedSalesPerson);
  };

  return (
    <>
      <Navbar user={user} onLogout={onLogout} />
      <HomeContainer>
        <Header>
          <HeaderTop>
            <Logo src={logo} alt="Sirdata Logo" />
            <UserInfo>
              <UserName>Bonjour, {user.username}</UserName>
              <LogoutButton onClick={handleLogout}>Déconnexion</LogoutButton>
            </UserInfo>
          </HeaderTop>
          <Title>Tableau de bord des annonceurs</Title>
          <Subtitle>
            Visualisez et analysez les performances de vos annonceurs
            {userRole === "admin" ? (
              <span> (Mode Administrateur - Accès à tous les annonceurs)</span>
            ) : (
              <span> (Mode Commercial - Accès limité à vos annonceurs)</span>
            )}
          </Subtitle>
          <HeaderButtons>
            <HeaderButton onClick={() => navigate("/reports")}>
              <span>📋</span> Voir tous les rapports
            </HeaderButton>
          </HeaderButtons>
        </Header>
        <DateRangeSelector>
          <DateRangeLabel>Période du rapport</DateRangeLabel>
          <DateInputGroup>
            <DateInputContainer>
              <DateRangeLabel>Date de début</DateRangeLabel>
              <DateInput
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </DateInputContainer>
            <DateInputContainer>
              <DateRangeLabel>Date de fin</DateRangeLabel>
              <DateInput
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </DateInputContainer>
          </DateInputGroup>
        </DateRangeSelector>
        {/* Nouvelle barre de recherche */}
        <SearchContainer>
          <SearchIcon>🔍</SearchIcon>
          <SearchInput
            type="text"
            placeholder="Rechercher un annonceur..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {searchTerm && <ClearButton onClick={clearSearch}>✕</ClearButton>}
        </SearchContainer>
        <SalesPersonFilter>
          <label>Filtrer par commercial:</label>
          <SalesPersonSelect
            value={selectedSalesPerson}
            onChange={(e) => setSelectedSalesPerson(e.target.value)}
          >
            <option value="">Tous les commerciaux</option>
            {salesPersons.map((person) => (
              <option key={person} value={person}>
                {person}
              </option>
            ))}
          </SalesPersonSelect>
          <ActionButton onClick={filterBySalesPerson}>Appliquer</ActionButton>
        </SalesPersonFilter>
        <RefreshButton onClick={syncAdvertisers} disabled={syncing}>
          {syncing ? "Synchronisation..." : "Synchroniser avec Xandr"}
        </RefreshButton>
        <div
          style={{
            padding: "10px",
            backgroundColor: "#e6f7ff",
            borderRadius: "4px",
            marginBottom: "20px",
            color: "#0070f3",
          }}
        >
          {syncMessage}
        </div>
        <SectionTitle>
          Annonceurs disponibles{" "}
          {searchTerm &&
            `(Filtré: ${advertisers.length}/${advertisers.length})`}
        </SectionTitle>
        {error && <ErrorContainer>{error}</ErrorContainer>}
        {loading ? (
          <LoadingContainer>Chargement des annonceurs...</LoadingContainer>
        ) : advertisers.length === 0 ? (
          searchTerm ? (
            <NoResultsContainer>
              Aucun annonceur ne correspond à votre recherche "{searchTerm}"
            </NoResultsContainer>
          ) : (
            <LoadingContainer>Aucun annonceur trouvé</LoadingContainer>
          )
        ) : (
          <AdvertisersList>
            {advertisers.map((advertiser) => (
              <AdvertiserCard key={advertiser.advertiserId}>
                <AdvertiserName>{advertiser.name}</AdvertiserName>
                <AdvertiserInfo>
                  <InfoItem>
                    <InfoLabel>ID:</InfoLabel>
                    <InfoValue>{advertiser.advertiserId}</InfoValue>
                  </InfoItem>
                  <InfoItem>
                    <InfoLabel>État:</InfoLabel>
                    <InfoValue>
                      {advertiser.state === "active" ? "Actif" : "Inactif"}
                    </InfoValue>
                  </InfoItem>
                  <InfoItem>
                    <InfoLabel>Commercial:</InfoLabel>
                    <InfoValue>
                      {advertiser.salesPerson || "Non assigné"}
                    </InfoValue>
                  </InfoItem>
                  <InfoItem></InfoItem>
                  <InfoItem>
                    <InfoLabel>Créé le:</InfoLabel>
                    <InfoValue>{formatDate(advertiser.createdAt)}</InfoValue>
                  </InfoItem>
                </AdvertiserInfo>
                <RefreshButton
                  onClick={() => handleCreateReport(advertiser.advertiserId)}
                  disabled={generatingReport === advertiser.advertiserId}
                >
                  {generatingReport === advertiser.advertiserId
                    ? "Génération..."
                    : "Générer un rapport"}
                </RefreshButton>
              </AdvertiserCard>
            ))}
          </AdvertisersList>
        )}
      </HomeContainer>
    </>
  );
}

export default HomePage;
